import { render } from "./PlayCircleOutline.vue?vue&type=template&id=fa16a63c"
import script from "./PlayCircleOutline.vue?vue&type=script&lang=js"
export * from "./PlayCircleOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__